module.exports = __webpack_public_path__ + "static/media/dannyquist.6fba2e87.jpg";